import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { Flex } from '@/components/layout/Flex'

export const ErrorMessageOrderDetailNotFound = () => {
  const { t } = useTranslation()

  return (
    <Flex center direction={'column'} className={clsx('tw-mt-10')}>
      <p className={clsx('tw-font-semibold tw-text-sm')}>
        {t('pages.error.orderHistoryDetailNotFound.message.line1')}
        <br />
        {t('pages.error.orderHistoryDetailNotFound.message.line2')}
      </p>
      <p className={clsx('tw-mt-8 tw-text-sm')}>
        {t('pages.error.orderHistoryDetailNotFound.note.line1')}
        <br />
        {t('pages.error.orderHistoryDetailNotFound.note.line2')}
      </p>
    </Flex>
  )
}
